/**
 * Implements a report menu item to be added dynamically for drilldowns.
 */

import GenericMenuItem from "./generic/menu-item";

import { slugify } from "../utils";

const Model = GenericMenuItem.extend({
  initialize() {
    this.set({
      id: +_.uniqueId(),
      category: "drilldown",

      // keep a copy of original data
      originalData: this.getData(),

      // create route name from path
      name: slugify(this.getPath()),

      createdTimestamp: new Date(),
    });
  },
});

export { Model as default };
